Pixlee.module('Behaviors', function(Behaviors, App, Backbone, Marionette, $) {

    Behaviors.Upload = Marionette.Behavior.extend({
        ui: {
            uploadNow: '#upload_now'
        },
        initialize: function() {
            if (gon.previewMode) {
                window.addEventListener('message', this.receiveDesignEditorMessages, false);
            }
        },
        events: {
            'click @ui.uploadNow': 'openUploader',
            'keydown @ui.uploadNow': 'openUploader'
        },
        onShow: function() {
            var displayOpts = App.displayOptions;
            var headerOpts = displayOpts.get('headerOptions');

            if (_.isFalsy(App.currentAlbum.get('public_contribution')) && Object.keys(headerOpts).length <= 1) {
                this.ui.uploadNow.remove();
            } else if ((typeof displayOpts.get('pdpShowUploader') !== 'undefined') && _.isFalsy(displayOpts.get('pdpShowUploader'))) {
                // This is a PDP widget
                this.ui.uploadNow.remove();
            }

            var isUploaderHidden = this.ui.uploadNow.is(':hidden');
            var isTile = headerOpts.layout === 'tile';

            if (isTile && _.isFalsy(headerOpts.showViewGallery ||
                    headerOpts.showDescription || headerOpts.showTitle || !isUploaderHidden)) {
                $('#header_tile_container').remove();
            }
        },
        openUploader: function(ev) {
            // Keycode 13 = Enter Key
            if (ev.type === 'keydown' && ev.keyCode !== 13) {
                return;
            }
            var message = {
                name: 'pixlee:show:uploader',
                type: 'action',
                source: 'widget',
                destination: 'parent',
                data: {
                    widgetId: window.location.href,
                    // For accessiblity purposes: tracking whether user is using keyboard/mouse
                    // Used to keep track of using-keyboard or using-mouse for uploader
                    usingKeyboard: ev.type === 'keydown'
                }
            };

            if (this.designEditorDevice) {
                // used to spoof a different user agent in DE
                message.data.designEditorDevice = this.designEditorDevice;
            }
            window.lastElement = this.ui.uploadNow;
            window.parent.postMessage(JSON.stringify(message), '*');
        },
        receiveDesignEditorMessages: function() {
            // used to spoof a different user agent in DE
            var _this = this;
            var receiveMessage = _.throttle(function(event) {
                try {
                    var eventData = JSON.parse(event.data);

                    if (eventData.name === 'pixlee:design:editor:device') {
                        _this.designEditorDevice = eventData.data.deviceType;
                    }
                } catch (e) {
                    return;
                }
            }, 1000);
        }
    });

});
